skrilla.directive('userMarketingCategoryEventAudits',function() {
    return {
        templateUrl: 'directives/userMarketingCategoryEventAudits/userMarketingCategoryEventAudits.html',
        scope: {
            id: "=",
            key: "="
        },
        controller: function($scope, searchService, paginationService){

            $scope.reset = function () {
                $scope.query = {
                    limit: 20
                };
            };
            $scope.reset();

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getMarketingCategoryHistory, $scope.key);
            }

            function getMarketingCategoryHistory() {
                return searchService.get(`users/${$scope.id}/marketingCategories`).then(function (response) {
                    $scope.marketingCategoryEvents = response.data;
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

        }
    };
});
